/**
 * Design System - Utility Functions
 *
 * Helper functions for the design system
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines class names with tailwind-merge for proper conflict resolution
 * @param inputs - Class names to combine
 * @returns Merged class string
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Type-safe variant selector
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function variant<T extends Record<string, any>>(
  variants: T,
  selected: keyof T
): T[keyof T] {
  return variants[selected];
}
